<template>
  <div :class="[device_platform]">
    <div class="blacking" @click="hideSelf"></div>
    <div class="agreement-container">
      <div class="close" @click="hideSelf">&times;</div>
      <div class="agreement-text">
        <div class="agreement-header">
          СОГЛАСИЕ<br />
          на обработку персональных данных<br />
          (далее – «Согласие»)
        </div>
        <div class="agreement-part">
          Настоящим я свободно, своей волей и в своем интересе выражаю свое 
          безусловное согласие на обработку персональных данных Акционерному 
          обществу "Контекстус» (далее – Оператор), находящемуся по адресу: 
          г. Москва, ул. Малая Почтовая, д. 2/2, стр. 1, ИНН 9701179641 ОГРН 
          1217700286561. В соответствии с требованиями пп. 1 п. 1 статьи 6 и 
          статьи 9 Федерального закона от 27.07.06 «О персональных данных» № 
          152-ФЗ выражаю согласие на автоматизированную и без использования 
          средств автоматизации обработку, включая сбор, запись, систематизацию, 
          накопление, хранение, уточнение (обновление, изменение), извлечение, 
          использование, передачу (распространение, предоставление, доступ), 
          обезличивание, блокирование, удаление, уничтожение персональных данных, 
          моих персональные данные в целях информирования пользователя о товарах, 
          услугах и вакансиях Оператора посредством отправки электронных писем, 
          телефонных звонков, ведения переговоров о заключении гражданско-правовых 
          договоров, предоставления доступа пользователю к сервисам, информации 
          и/или материалам, содержащимся на веб-сайте. К персональным данным, на 
          обработку которых я даю настоящее согласие, относится: фамилия, имя, 
          отчество, номера контактных телефонов, адрес электронной почты, сведения, 
          содержащиеся в файлах cookie (время захода, данные user-agent, уникальный 
          идентификатор пользователя, иные не персонализированные сведения, необходимые 
          для корректной работы сайта Оператора). Настоящее согласие вступает в силу с 
          момента его подписания путем выбора соответствующего пункта в форме обратной 
          связи, расположенном на сайте Оператора по адресу 
          <a
            href="https://contextus.ru/"
            target="_blank"
            rel="noopener noreferrer"
          >
            https://contextus.ru/
          </a> 
          в течение срока хранения документов, содержащих мои персональные данные, 
          установленного действующим архивным законодательством. Я подтверждаю, 
          что мне известно о праве отозвать свое согласие посредством составления 
          соответствующего письменного документа, который может быть направлен 
          мной в адрес Оператора. Подтверждаю, что ознакомлен(-а) с Политикой 
          Оператора в отношении обработки персональных данных, и положениями 
          Федерального закона от 27 июля 2006 года № 152-ФЗ «О персональных 
          данных», права и обязанности в области защиты персональных данных 
          мне разъяснены и понятны.
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Mixin from "../common/mixin";

export default {
  name: "",
  props: ["type"],
  mixins: [Mixin],
  methods: {
    hideSelf() {
      this.$emit("close");
    },
  },
};
</script>

<style scoped lang="scss">
.mobile {
  .agreement-part {
    margin-bottom: 10px;
    overflow: auto;
    height: 100%;
    max-height: 50vh;
  }
}

.blacking {
  position: fixed;
  z-index: 1199;
  top: -100vh;
  left: -100vw;
  bottom: -100vw;
  right: -100vh;
  background: #000;
  opacity: 0.5;
  cursor: default;
}

.agreement-container {
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 80%;
  height: 70%;
  position: fixed;
  z-index: 1200;
  background: #fff;
  padding: 30px 20px;
  cursor: default;
  color: #000;

  .close {
    position: absolute;
    font-size: 30px;
    top: 10px;
    right: 15px;
    cursor: pointer;
  }
}

.agreement-text {
  font-size: 16px;
  height: 90%;

  a {
    color: inherit;
  }
}
.agreement-header {
  font-size: 18px;
  font-weight: 600;
  text-align: center;
  margin-bottom: 20px;
  text-transform: uppercase;
}

.agreement-part {
  margin-bottom: 10px;
  overflow: auto;
  height: 100%;
}

@media screen and (max-width: 800px) {
  .agreement-container {
    width: 90%;
    height: auto;
  }

  .agreement-text {
    font-size: 14px;
  }

  .agreement-header {
    font-size: 16px;
  }
}
</style>
